'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Menu;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _containers = require('../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Menu() {
  return _react2.default.createElement(
    'nav',
    { className: 'Menu' },
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: 'https://nouvelles.cegepsl.qc.ca/' },
          'Nouvelles'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: 'https://www.cegepsl.qc.ca/cegep/' },
          'Le C\xE9gep'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(_containers.SearchBarContainer, null)
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu.js
// module id = 1170
// module chunks = 0